import React from 'react'
import queryStringToJson from '../utils/queryStringToJson';

const UserAgentCheckWrapper = ({ children }) => {
  // 무버스 앱인지 아닌지 확인
  const [isMovusApp, setIsMovusApp] = React.useState(null);
  // PC 환경에서 접근 할 api 환경정의
  const [auth, setAuth] = React.useState(null);
  // 무버스 앱 검증로직 임시 해제
  const isBypass = true;

  var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

  React.useEffect(() => {
    // 기타 환경에서 무버스 앱 검증
    const devHost = ['10.106.22.176'];
    const findDevHost = !!devHost.find(item=>item === window.location.hostname);

    if (varUA.indexOf("android") > -1) {
      // 안드로이드 환경에서 무버스 앱 검증
      setIsMovusApp(varUA.indexOf("movus-aos") > -1 || findDevHost)
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
      ) {
      // 안드로이드 환경에서 무버스 앱 검증
      setIsMovusApp(varUA.indexOf("movus-ios") > -1 || findDevHost)
    } else {
      // Local PC환경에서 api서버 대상을 정의합니다.
      const queryString = window.location.search;
      const queryObject = queryStringToJson(queryString);
      if ('auth' in queryObject && (
        queryObject.auth === 'local' ||
        queryObject.auth === 'dev' ||
        queryObject.auth === 'stg'
      )) {
        // URL queryString에서 auth의 값으로 대상 api서버를 특정합니다.
        setAuth(queryObject.auth);
      }
      setIsMovusApp(findDevHost);
    }
  }, [varUA]);

  // 무버스 앱이 아닐때
  if (isMovusApp === null) {
    return <div className="container terms_wrap">환경 체크중입니다.</div>;
  }
  
  if (!isMovusApp && auth === null && !isBypass) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{
          color: 'white'
        }}>
        무버스 앱을 이용해주세요.
        </div>
      </div>
    );
  }

  return <>{children}</>
}

export default UserAgentCheckWrapper